import { Pipe, PipeTransform } from 'angular-ts-decorators';

export type EscapeRegexFilter = (input: any) => any;

interface IEscapeRegex {
  transform: EscapeRegexFilter;
}

/**
 * Escape regex special keys from string
 * @param Input string
 * @return Escaped string
 */
@Pipe({ name: 'escapeRegex' })
export class EscapeRegexPipe implements PipeTransform, IEscapeRegex {
  constructor() {
    'ngInject';
  }

  public transform(input: string): string {
    const stringifyInput = String(input);

    return stringifyInput
      .replaceAll('.', '\\.')
      .replaceAll('?', '\\?')
      .replaceAll('+', '\\+')
      .replaceAll('$', '\\$')
      .replaceAll('^', '\\^');
  }
}
